import type { FunctionComponent } from 'react';

import { JobSettingsForm } from './components';

const Content: FunctionComponent = function () {
  return (
    <div className="flex flex-col gap-y-6">
      <JobSettingsForm />
    </div>
  );
};

export default Content;
